import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["checked", "onChange", "disabled", "error", "isDark", "darkMode", "label", "small", "className", "wrapperProps", "data-testid", "htmlProps", "inputProps"];
import cn from 'classnames';
import { Checkmark } from '@crehana/icons/outline';
import transition from "../styles/transition";
import { CHECKBOX, DISABLED_WRAPPER, WRAPPER } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Checkbox = function Checkbox(_ref) {
  var _cn;
  var checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    error = _ref.error,
    isDark = _ref.isDark,
    darkMode = _ref.darkMode,
    label = _ref.label,
    small = _ref.small,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    wrapperProps = _ref.wrapperProps,
    dataTestId = _ref['data-testid'],
    htmlProps = _ref.htmlProps,
    inputProps = _ref.inputProps,
    checkboxProps = _objectWithoutProperties(_ref, _excluded);
  var type = 'default';
  if (error) {
    type = 'error';
  }
  if (checked) {
    type = isDark || darkMode ? 'checked-dark' : 'checked';
  }
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread(_objectSpread({
    className: cn(disabled ? DISABLED_WRAPPER : WRAPPER, className)
  }, wrapperProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      className: "hidden",
      type: "checkbox",
      disabled: disabled,
      onChange: onChange,
      "data-testid": dataTestId
    }, checkboxProps), inputProps)), /*#__PURE__*/_jsx(_StyledDiv, {
      className: cn(CHECKBOX[type], 'text-white'),
      $_css: transition(['background-color', 'border']),
      $_css2: transition('opacity'),
      children: /*#__PURE__*/_jsx(Checkmark, {
        className: cn('fill-current', !checked ? 'opacity-0' : 'opacity-1'),
        size: 16,
        ignoreColor: true
      })
    }), label && /*#__PURE__*/_jsx("span", {
      className: cn(small ? 'font-caption ml-8' : 'font-body3 ml-16', (_cn = {}, _defineProperty(_cn, isDark || darkMode ? 'text-white' : 'text-base-main', !disabled), _defineProperty(_cn, 'text-gray-dark', disabled), _cn)),
      style: {
        transition: transition('color')
      },
      children: label
    })]
  }));
};
export default Checkbox;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-fh48j2-0"
})(["\n          transition: ", ";\n          & svg {\n            transition: ", ";\n          }\n        "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});